import React from 'react';
import { useSelector } from 'react-redux';
import { optimizationPricesResultSelector } from '../../../../../../../reducers/OtimizacaoPrecos';
import { ChartVariationContainer } from './ChartVariation';

interface ChartVariationRevenueProps {
  isLoading: boolean;
  containerRefCharts: any;
}
export const ChartVariationRevenue = ({ isLoading, containerRefCharts }: ChartVariationRevenueProps) => {
  const { tabs } = useSelector(optimizationPricesResultSelector);
  const { charts } = tabs.analysis;

  return (
    <ChartVariationContainer
      containerRefCharts={containerRefCharts}
      chart={charts.revenue}
      title="Gráfico da variação de faturamento"
      titleYAxis="variação de faturamento"
      isLoading={isLoading}
    />
  );
};
